import { Controller } from "@hotwired/stimulus"

// Top-level keyboard listener for the intern_tasks page.
// - n   → trigger "+ New Task" (when not in an input)
// - Esc → close side panel, cancel inline edit, or cancel new-task row
// - Enter (when row focused) → open side panel
// - ↑/↓ → move row focus
export default class extends Controller {
  connect() {
    this.handler = this.onKey.bind(this)
    document.addEventListener("keydown", this.handler)
    this.focusedIndex = -1
  }

  disconnect() {
    document.removeEventListener("keydown", this.handler)
  }

  onKey(event) {
    if (this.isInInput(event.target)) {
      if (event.key === "Escape") this.handleEscape(event)
      return
    }

    if (event.key === "n" && !event.metaKey && !event.ctrlKey) {
      event.preventDefault()
      this.triggerNewTask()
    } else if (event.key === "Escape") {
      this.handleEscape(event)
    } else if (event.key === "Enter" && this.focusedIndex >= 0) {
      event.preventDefault()
      this.openFocusedRow()
    } else if (event.key === "ArrowDown") {
      event.preventDefault()
      this.moveFocus(1)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.moveFocus(-1)
    }
  }

  isInInput(el) {
    if (!el) return false
    const tag = el.tagName
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable
  }

  triggerNewTask() {
    const ctl = this.element.querySelector("[data-controller~='intern-task-create']")
    if (!ctl) return
    const button = document.querySelector("[data-action*='intern-task-create#startNew']")
    if (button) button.click()
  }

  handleEscape(event) {
    // 1) Close side panel if open
    const panel = document.querySelector("[data-controller~='side-panel']")
    if (panel && !panel.hidden) {
      panel.dispatchEvent(new CustomEvent("side-panel:close", { bubbles: true }))
      return
    }
    // 2) Cancel new-task row if present
    const newRow = document.querySelector(".new-task-row")
    if (newRow) {
      newRow.remove()
      return
    }
    // 3) Blur the active element (cancels inline cell edit via its own listener)
    document.activeElement?.blur?.()
  }

  rows() {
    return Array.from(document.querySelectorAll(".task-row[data-task-id]"))
  }

  moveFocus(delta) {
    const rows = this.rows()
    if (rows.length === 0) return
    this.clearFocus(rows)
    this.focusedIndex = Math.max(0, Math.min(rows.length - 1, this.focusedIndex + delta))
    if (this.focusedIndex < 0) this.focusedIndex = 0
    const target = rows[this.focusedIndex]
    target.classList.add("ring-2", "ring-[#C4A484]", "ring-offset-1")
    target.scrollIntoView({ block: "nearest", behavior: "smooth" })
  }

  clearFocus(rows) {
    rows.forEach((r) => r.classList.remove("ring-2", "ring-[#C4A484]", "ring-offset-1"))
  }

  openFocusedRow() {
    const rows = this.rows()
    const row = rows[this.focusedIndex]
    if (row) row.click()
  }
}
